import React, { FC } from 'react';
import { ItineraryDecorationProps } from '@components/Results/Components/ThreeColumnsItinerary/types';
import { HighlightedType } from '@components/Results/Components/ItineraryHeader/constants/highlightedTypes';
import { Card, HighlightedCard } from '@edreamsodigeo/prisma-design-system';
import { ThreeColumnsItineraryDecoration } from '@components/Results/Components/ThreeColumnsItinerary/ThreeColumnsItineraryDecoration/ThreeColumnsItineraryDecoration';
import { usePrime } from 'clientState/providers/PrimeProvider';

const ItineraryPrimeDaysDecoration: FC<ItineraryDecorationProps> = ({
  children,
  highlightedType,
  primeDayConfig,
  hasRetailingTechniques,
  isAlternativeItinerary,
  hasAlternativeItineraryDecorator,
  isAlternativeItineraryOnModal,
  isUnavailable = false,
  ...props
}) => {
  const { isPrimeDayFare, primeDayFareType } = primeDayConfig || {};
  const primeDayCondition =
    isPrimeDayFare && primeDayFareType && primeDayFareType !== 'BRONZE';
  const Component =
    (highlightedType === 'recommended' || primeDayCondition) &&
    hasRetailingTechniques &&
    !isAlternativeItinerary &&
    !isUnavailable
      ? HighlightedCard
      : Card;

  let type;
  if (highlightedType === 'recommended' && hasRetailingTechniques) {
    type = 'positive';
  } else if (primeDayCondition && hasRetailingTechniques) {
    type = 'promotional';
  }

  const sx =
    (isAlternativeItinerary && !hasAlternativeItineraryDecorator) ||
    isUnavailable
      ? {
          backgroundColor: 'neutral.20',
          border: '1px solid',
          borderColor: 'neutral.60',
        }
      : {};

  const sxOnLayer =
    !isAlternativeItinerary && isAlternativeItineraryOnModal
      ? { border: '1px solid', borderColor: 'neutral.60', boxShadow: 'none' }
      : {};

  const { isUK, isPrimeUser, isPrimeSite } = usePrime() || {};
  const withUKStyle = isUK && !isPrimeUser && isPrimeSite;

  const withPrimeDayHeader =
    primeDayCondition &&
    primeDayFareType === 'GOLD' &&
    highlightedType !== HighlightedType.Recommended &&
    !isAlternativeItinerary &&
    !isUnavailable;

  return (
    <ThreeColumnsItineraryDecoration
      Component={Component}
      highlightedType={highlightedType}
      hasRetailingTechniques={hasRetailingTechniques}
      type={type}
      withPrimeDayHeader={withPrimeDayHeader}
      {...props}
      sx={{ ...sx, ...sxOnLayer }}
      p={withUKStyle ? '0' : 'base'}
    >
      {children}
    </ThreeColumnsItineraryDecoration>
  );
};

export default ItineraryPrimeDaysDecoration;
